import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Card, Button } from 'day8-ui';
import { PiBoat } from "@react-icons/all-files/pi/PiBoat";
import { CiCalendar } from "@react-icons/all-files/ci/CiCalendar";
import { RxCross1 } from "@react-icons/all-files/rx/RxCross1";
import { MdOutlineArrowForward } from "@react-icons/all-files/md/MdOutlineArrowForward";
import CancelModal from './CancelModal';
import { getConfirmEventName } from '../../helpers/week';
import WeekNumber from '../booking-options/BookingOption/components/WeekNumber';

class PlanCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.openCancelModal = this.openCancelModal.bind(this);
    this.closeCancelModal = this.closeCancelModal.bind(this);
  }

  openCancelModal() {
    this.setState({ cancelModalOpen: true });
  }

  closeCancelModal() {
    this.setState({ cancelModalOpen: false });
  }

  render() {
    const { cancelModalOpen } = this.state;
    const { plan, user } = this.props;
    const eventName = getConfirmEventName(plan.destination.name || "Destination", null, plan?.week);
    const boatType = plan.standardYachtWeek?.standardYacht?.package?.name || plan?.boatWeek?.boat?.type || "N/A";
    const interestedMembers = (plan.crewMembers || []).filter(member => member.status !== 'deleted' && member.profile.id !== user.id) || [];
    return (
      <Card cardType='BORDERED'>
        <div className='dui-flex dui-justify-between dui-items-center'>
          <h2>{eventName}</h2>
          {plan.booker.id === user.id && plan.status !== 'ok' && (
            <div className='dui--m-4'>
              <Button
                buttonType='LINK'
                buttonSize='SMALL'
                rightIcon={<RxCross1 />}
                onClick={e => {
                  e.preventDefault();
                  this.setState({ cancelModalOpen: true });
                }}
              />
            </div>
          )}
        </div>
        <div className='dui-flex dui-items-center dui-gap-2'>
          <div className='dui-my-2 dui-flex dui-items-center dui-gap-2'>
            <PiBoat />
            <p>{boatType}</p>
          </div>
          {plan?.week ? (
            <WeekNumber className='dui-flex dui-items-center dui-gap-2' week={plan.week.week} iconClassName={'dui-w-4 dui-h-4'}/>
          ) : (
            <div className='dui-flex dui-items-center dui-gap-2'>
              <CiCalendar />
              <p>N/A</p>
            </div>
          )}
        </div>
        <div className='dui-flex dui-items-center dui-gap-2'>
          <p>Invited: <span className='dui-font-medium'>{interestedMembers.length}</span></p>
        </div>
        <Link to={`/plan/${plan.alphaId}`}>
          <Button className='dui-mt-2' buttonType="LINK" rightIcon={<MdOutlineArrowForward />}>Go to plan</Button>
        </Link>
        {cancelModalOpen && (
          <CancelModal
            onCloseModal={this.closeCancelModal}
            modalIsOpen={cancelModalOpen}
            planCode={plan.alphaId}
          />
        )}
      </Card>
    );
  }
}

PlanCard.propTypes = {
  plan: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired
};

export default PlanCard;
